import { render, staticRenderFns } from "./CardLoading.vue?vue&type=template&id=a5be46d8&scoped=true"
import script from "./CardLoading.vue?vue&type=script&lang=js"
export * from "./CardLoading.vue?vue&type=script&lang=js"
import style0 from "./CardLoading.vue?vue&type=style&index=0&id=a5be46d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5be46d8",
  null
  
)

export default component.exports